import './styles/MembersList.scss';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext, ExAppContext } from '../Context';
import { useContext, useState, useRef, useEffect, Fragment, ReactElement } from 'react';
import { Browser } from '@capacitor/browser';
import { Clipboard } from '@capacitor/clipboard';

//classes
import Member from '../classes/member';
import MemberType from '../exClasses/memberType';
class NameListMap {
    memberID: string = '';
    name: string = '';
};

//controllers
import DatabaseInterfaceController from '../controllers/DatabaseInterfaceController';

//muis
import SearchIcon from '@mui/icons-material/Search';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { isPlatform } from '@ionic/react';

const nonstate = {
    alphabetMap: {
        '0': 0,
        '1': 1,
        '2': 2,
        '3': 3,
        '4': 4,
        '5': 5,
        '6': 6,
        '7': 7,
        '8': 8,
        '9': 9,
        'a': 11,
        'b': 12,
        'c': 13,
        'd': 14,
        'e': 15,
        'f': 16,
        'g': 17,
        'h': 18,
        'i': 19,
        'j': 20,
        'k': 21,
        'l': 22,
        'm': 23,
        'n': 24,
        'o': 25,
        'p': 26,
        'q': 27,
        'r': 28,
        's': 29,
        't': 30,
        'u': 31,
        'v': 32,
        'w': 33,
        'x': 34,
        'y': 35,
        'z': 36
    }
}

interface Props {

}

const MembersList: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [filter_searchString, SetFilter_searchString] = useState<string>('');
    const [filter_memberTypeID, SetFilter_memberTypeID] = useState<string>('');
    // const [membersList, SetMembersList] = useState<Member[]>([] as Member[]);
    // const [nameList, SetNameList] = useState<NameListMap[]>([] as NameListMap[]); //name list for individual users --deprecated, too lag
    const [corporateMemberList, SetCorporateMemberList] = useState<Member[]>([] as Member[]);
    const [individualMemberList, SetIndividualMemberList] = useState<Member[]>([] as Member[]);
    const [honoraryMemberList, SetHonoraryMemberList] = useState<Member[]>([] as Member[]);
    const [associateMemberList, SetAssociateMemberList] = useState<Member[]>([] as Member[]);
    const [affiliateCorporateMemberList, SetAffiliateCorporateMemberList] = useState<Member[]>([] as Member[]);
    const [affiliateIndividualMemberList, SetAffiliateIndividualMemberList] = useState<Member[]>([] as Member[]);
    const [individualMemberNameList, SetIndividualMemberNameList] = useState<NameListMap[]>([] as NameListMap[]);
    const [honoraryMemberNameList, SetHonoraryMemberNameList] = useState<NameListMap[]>([] as NameListMap[]);
    const [associateMemberNameList, SetAssociateMemberNameList] = useState<NameListMap[]>([] as NameListMap[]);
    const [affiliateIndividualMemberNameList, SetAffiliateIndividualMemberNameList] = useState<NameListMap[]>([] as NameListMap[]);

    const [selectedMember, SetSelectedMember] = useState<Member>({} as Member);
    //refs
    const memberListScrollRef = useRef<any>(null);
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    // useEffect(() => {
    //     console.log('MemberListTest: ' + JSON.stringify(affiliateCorporateMemberList));
    // }, [affiliateCorporateMemberList]);

    //initialization
    useEffect(() => {
        databaseInterfaceController.Queue('fetchMembersList', [
            ['fetchMembersList', 'true']
        ]);
        SetFilter_memberTypeID(GetMemberTypeIDByLabel('Corporate'));
    }, []);

    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchMembersList':
                        if (!JSON.stringify(res).includes('_false')) {
                            let jsonObjs = [] as any[];
                            try {
                                jsonObjs = JSON.parse(res) as any[];
                            } catch {
                                jsonObjs = res as any[];
                            }
                            // const _membersList = [] as Member[];
                            // const _nameList = [] as NameListMap[];
                            // jsonObjs.map((jsonObj: any) => {
                            //     _membersList.push(new Member(
                            //         '',
                            //         jsonObj['memberID'],
                            //         jsonObj['member_typeID'],
                            //         '', ' ',
                            //         jsonObj['company_name'],
                            //         '', '',
                            //         jsonObj['complex_representing'],
                            //         jsonObj['telephone_no'],
                            //         jsonObj['email'],
                            //         '', '',
                            //         jsonObj['website'],
                            //         '', ''
                            //     ));
                            //     _nameList.push({memberID: jsonObj['memberID'], name: jsonObj['name']} as NameListMap);
                            // });
                            // SetMembersList([..._membersList]);
                            // SetNameList([..._nameList]); --deprecated due to lagging
                            // console.log('checkNamelist: ' + JSON.stringify(_nameList));

                            const _corporateMemberList = [] as Member[];
                            const _individualMemberList = [] as Member[];
                            const _honoraryMemberList = [] as Member[];
                            const _associateMemberList = [] as Member[];
                            const _affiliateCorporateMemberList = [] as Member[];
                            const _affiliateIndividualMemberList = [] as Member[];

                            const _individualMemberNameList = [] as NameListMap[];
                            const _honoraryMemberNameList = [] as NameListMap[];
                            const _associateMemberNameList = [] as NameListMap[];
                            const _affiliateIndividualMemberNameList = [] as NameListMap[];

                            jsonObjs.map((jsonObj: any) => {
                                if (MatchMemberTypeIDWithLabel(jsonObj['member_typeID'], 'Corporate')) {
                                    _corporateMemberList.push(new Member(
                                        '',
                                        jsonObj['memberID'],
                                        jsonObj['member_typeID'],
                                        '', ' ',
                                        jsonObj['company_name'],
                                        '', '',
                                        jsonObj['complex_representing'],
                                        jsonObj['telephone_no'],
                                        jsonObj['email'],
                                        '', '',
                                        jsonObj['website'],
                                        '', '', '', ''
                                    ));
                                } else if (MatchMemberTypeIDWithLabel(jsonObj['member_typeID'], 'Individual')) {
                                    _individualMemberList.push(new Member(
                                        '',
                                        jsonObj['memberID'],
                                        jsonObj['member_typeID'],
                                        '', ' ',
                                        jsonObj['company_name'],
                                        '', '',
                                        jsonObj['complex_representing'],
                                        jsonObj['telephone_no'],
                                        jsonObj['email'],
                                        '', '',
                                        jsonObj['website'],
                                        '', '', '', ''
                                    ));
                                    _individualMemberNameList.push({ memberID: jsonObj['memberID'], name: jsonObj['name'] } as NameListMap);
                                } else if (MatchMemberTypeIDWithLabel(jsonObj['member_typeID'], 'Honorary Member')) {
                                    _honoraryMemberList.push(new Member(
                                        '',
                                        jsonObj['memberID'],
                                        jsonObj['member_typeID'],
                                        '', ' ',
                                        jsonObj['company_name'],
                                        '', '',
                                        jsonObj['complex_representing'],
                                        jsonObj['telephone_no'],
                                        jsonObj['email'],
                                        '', '',
                                        jsonObj['website'],
                                        '', '',  '', ''
                                    ));
                                    _honoraryMemberNameList.push({ memberID: jsonObj['memberID'], name: jsonObj['name'] } as NameListMap);
                                } else if (MatchMemberTypeIDWithLabel(jsonObj['member_typeID'], 'Associate')) {
                                    _associateMemberList.push(new Member(
                                        '',
                                        jsonObj['memberID'],
                                        jsonObj['member_typeID'],
                                        '', ' ',
                                        jsonObj['company_name'],
                                        '', '',
                                        jsonObj['complex_representing'],
                                        jsonObj['telephone_no'],
                                        jsonObj['email'],
                                        '', '',
                                        jsonObj['website'],
                                        '', '', '', ''
                                    ));
                                    _associateMemberNameList.push({ memberID: jsonObj['memberID'], name: jsonObj['name'] } as NameListMap);
                                } else if (MatchMemberTypeIDWithLabel(jsonObj['member_typeID'], 'Affiliate Corporate')) {
                                    _affiliateCorporateMemberList.push(new Member(
                                        '',
                                        jsonObj['memberID'],
                                        jsonObj['member_typeID'],
                                        '', ' ',
                                        jsonObj['company_name'],
                                        '', '',
                                        jsonObj['complex_representing'],
                                        jsonObj['telephone_no'],
                                        jsonObj['email'],
                                        '', '',
                                        jsonObj['website'],
                                        '', '', '', ''
                                    ));
                                } else if (MatchMemberTypeIDWithLabel(jsonObj['member_typeID'], 'Affiliate Individual')) {
                                    _affiliateIndividualMemberList.push(new Member(
                                        '',
                                        jsonObj['memberID'],
                                        jsonObj['member_typeID'],
                                        '', ' ',
                                        jsonObj['company_name'],
                                        '', '',
                                        jsonObj['complex_representing'],
                                        jsonObj['telephone_no'],
                                        jsonObj['email'],
                                        '', '',
                                        jsonObj['website'],
                                        '', '', '', ''
                                    ));
                                    _affiliateIndividualMemberNameList.push({ memberID: jsonObj['memberID'], name: jsonObj['name'] } as NameListMap);
                                }
                            });
                            SetCorporateMemberList([..._corporateMemberList]);
                            SetIndividualMemberList([..._individualMemberList]);
                            SetHonoraryMemberList([..._honoraryMemberList]);
                            SetAssociateMemberList([..._associateMemberList]);
                            SetAffiliateCorporateMemberList([..._affiliateCorporateMemberList]);
                            SetAffiliateIndividualMemberList([..._affiliateIndividualMemberList]);

                            SetIndividualMemberNameList([..._individualMemberNameList]);
                            SetHonoraryMemberNameList([..._honoraryMemberNameList]);
                            SetAssociateMemberNameList([..._associateMemberNameList]);
                            SetAffiliateIndividualMemberNameList([..._affiliateIndividualMemberNameList]);
                        } else {
                            console.log('fetchMembersListErr: ' + res);
                        }
                        break;
                }
            }
            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchMembersList':
                    ExecuteDatabaseResultAction();
                    break;
            }

        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //watch for filter_memberTypeID update, auto scroll to top
    useEffect(() => {
        if (memberListScrollRef.current != null) {
            memberListScrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [filter_memberTypeID]);

    //ui functions
    const OnNavigateToWebsiteclicked = async (website: string) => {
        let _website = (website.includes('https://') ? website : 'https://' + website);
        try {
            await Browser.open({ url: _website });
        } catch (err: any) {
            appContext.SetPopupMessage('Unable to open the website, copy link instead?');
            appContext.SetPopupButtons(['Copy Link', 'Cancel']);
            appContext.SetPopupActions([async () => {
                if (isPlatform('hybrid')) {
                    await Clipboard.write({ string: _website }).then(() => {
                        appContext.SetPopupMessage('The website link: ' + _website + ' is copied to clipboard.');
                    });
                } else {
                    navigator.clipboard.writeText(_website).then(() => {
                        appContext.SetPopupMessage('The website link: ' + _website + ' is copied to clipboard.');
                    });
                }
            }, () => { }]);
        }
    }

    //render functions
    const RenderMembersList = () => {
        const content = [] as ReactElement[];

        if (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Corporate')) {
            let filteredList = FilterListBySearchString(corporateMemberList);

            if (filteredList.length > 0) {
                SortAlphabetically(filteredList).map((member: Member, i: number) => {
                    content.push(RenderMemberListCard(member, i))
                });
            } else {
                content.push(
                    <span className='not-found-lbl'>No members found<br />Please check again later</span>
                );
            }
        } else if (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Individual')) {
            let filteredList = FilterListBySearchString(individualMemberList, individualMemberNameList);
            // console.log('checkList: ' + JSON.stringify(SortAlphabetically(filteredList)));

            if (filteredList.length > 0) {
                SortAlphabetically(filteredList).map((member: Member, i: number) => {
                    content.push(RenderMemberListCard(member, i))
                });
            } else {
                content.push(
                    <span className='not-found-lbl'>No members found<br />Please check again later</span>
                );
            }
        } else if (filter_memberTypeID == '') {
            let filteredHonoraryMemberList = FilterListBySearchString(honoraryMemberList, honoraryMemberNameList);
            let filteredAssociateMemberList = FilterListBySearchString(associateMemberList, associateMemberNameList);
            let filteredAffiliateCorporateMemberList = FilterListBySearchString(affiliateCorporateMemberList);
            let filteredAffiliateIndividualMemberList = FilterListBySearchString(affiliateIndividualMemberList, affiliateIndividualMemberNameList);

            if (
                filteredHonoraryMemberList.length > 0
                || filteredAssociateMemberList.length > 0
                || filteredAffiliateCorporateMemberList.length > 0
                || filteredAffiliateIndividualMemberList.length > 0
            ) {
                /** Honorary Member */
                if (filteredHonoraryMemberList.length > 0) {
                    content.push(<span className='member-list-subtitle'>Honorary Members</span>);
                    SortAlphabetically(filteredHonoraryMemberList).map((member: Member, i: number) => {
                        content.push(RenderMemberListCard(member, i));
                    });
                }
                /** Associate Member */
                if (filteredAssociateMemberList.length > 0) {
                    content.push(<span className='member-list-subtitle'>Associate Members</span>);
                    SortAlphabetically(filteredAssociateMemberList).map((member: Member, i: number) => {
                        content.push(RenderMemberListCard(member, i));
                    });
                }
                /** Affiliate Corporate */
                if (filteredAffiliateCorporateMemberList.length > 0) {
                    content.push(<span className='member-list-subtitle'>Affiliate (Corporate)</span>);
                    SortAlphabetically(filteredAffiliateCorporateMemberList).map((member: Member, i: number) => {
                        content.push(RenderMemberListCard(member, i));
                    });
                }
                /** Affiliate Individual */
                if (filteredAffiliateIndividualMemberList.length > 0) {
                    content.push(<span className='member-list-subtitle'>Affiliate (Individual)</span>);
                    SortAlphabetically(filteredAffiliateIndividualMemberList).map((member: Member, i: number) => {
                        content.push(RenderMemberListCard(member, i));
                    });
                }
            } else {
                content.push(
                    <span className='not-found-lbl'>No members found<br />Please check again later</span>
                );
            }

            // let filteredList = FilterListBySearchString(honoraryMemberList);

            // if (filteredList.length > 0) {
            //     SortAlphabetically(filteredList).map((member: Member, i: number) => {
            //         content.push(RenderMemberListCard(member, i))
            //     });
            // } else {
            //     content.push(
            //         <span className='not-found-lbl'>No members found<br />Please check again later</span>
            //     );
            // }
        } else if (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Associate')) {
            let filteredList = FilterListBySearchString(associateMemberList);

            if (filteredList.length > 0) {
                SortAlphabetically(filteredList).map((member: Member, i: number) => {
                    content.push(RenderMemberListCard(member, i))
                });
            } else {
                content.push(
                    <span className='not-found-lbl'>No members found<br />Please check again later</span>
                );
            }
        } else if (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Affiliate Corporate')) {
            let filteredList = FilterListBySearchString(affiliateCorporateMemberList);

            if (filteredList.length > 0) {
                SortAlphabetically(filteredList).map((member: Member, i: number) => {
                    content.push(RenderMemberListCard(member, i))
                });
            } else {
                content.push(
                    <span className='not-found-lbl'>No members found<br />Please check again later</span>
                );
            }
        } else if (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Affiliate Individual')) {
            let filteredList = FilterListBySearchString(affiliateIndividualMemberList);

            if (filteredList.length > 0) {
                SortAlphabetically(filteredList).map((member: Member, i: number) => {
                    content.push(RenderMemberListCard(member, i))
                });
            } else {
                content.push(
                    <span className='not-found-lbl'>No members found<br />Please check again later</span>
                );
            }
        }

        return content;
    }
    const RenderMemberListCard = (member: Member, index: number) => {
        return (
            <div className='member-list-card'>
                <div className='card-header' onClick={() => {
                    // if (!MatchMemberTypeIDWithLabel(member.member_typeID, 'Honorary Member')) {
                    //     selectedMember.memberID != member.memberID ?
                    //         SetSelectedMember(member)
                    //         :
                    //         SetSelectedMember({} as Member);
                    // }
                    selectedMember.memberID != member.memberID ?
                    SetSelectedMember(member)
                    :
                    SetSelectedMember({} as Member);
                }}>
                    <span className='card-no'>{(index + 1).toString() + '.'}</span>
                    <span className='card-title'>{
                        IsCorporate(member) ?
                            (
                                member.complex_representing.length > 0 && member.complex_representing != '-' ?
                                    member.complex_representing
                                    :
                                    member.company_name
                            )
                            :
                            GetNameListByFilterMemberTypeID(filter_memberTypeID).map((nameList: NameListMap) => {
                                if (nameList.memberID == member.memberID)
                                    return nameList.name;
                            })
                    }</span>
                    {
                        selectedMember.memberID != member.memberID ?
                            <MoreVertIcon />
                            :
                            null
                    }
                </div>
                <div className={'card-body ' + (selectedMember.memberID == member.memberID ? 'selected' : '') + (!IsCorporate(selectedMember) ? ' ex' : '')}>
                    {
                        member.email.length > 0
                            || member.telephone_no.length > 0
                            || member.website.length > 0 ?
                            <Fragment>
                                <div className='card-body-row'>
                                    {
                                        member.email.length > 0 ?
                                            <Fragment>
                                                <a className='card-body-lbl' href={"mailto:" + member.email}><EmailIcon />{member.email}</a>
                                                <ArrowForwardIosIcon />
                                            </Fragment>
                                            :
                                            <span className='card-body-lbl'><EmailIcon />Not Available</span>
                                    }
                                </div>
                                <div className='card-body-row'>
                                    {
                                        member.telephone_no.length > 0 ?
                                            <Fragment>
                                                <a className='card-body-lbl' href={"tel:" + member.telephone_no}><PhoneIcon />{member.telephone_no}</a>
                                                <ArrowForwardIosIcon />
                                            </Fragment>
                                            :
                                            <span className='card-body-lbl'><PhoneIcon />Not Available</span>
                                    }
                                </div>
                                {
                                    IsCorporate(selectedMember) ?
                                        <div className='card-body-row'>
                                            {
                                                member.website.length > 0 ?
                                                    <Fragment>
                                                        <div className='card-body-lbl' onClick={() => OnNavigateToWebsiteclicked(member.website)}><LanguageIcon />{member.website}</div>
                                                        <ArrowForwardIosIcon />
                                                    </Fragment>
                                                    :
                                                    <span className='card-body-lbl'><LanguageIcon />Not Available</span>
                                            }
                                        </div>
                                        :
                                        null
                                }
                            </Fragment>
                            :
                            <div className='card-body-row ex'>
                                <span className='card-body-lbl'>
                                    No Records Available
                                </span>
                            </div>
                    }
                </div>
            </div>
        )
    }

    //exe functions
    // const FilterListByMemberType = (_membersList: Member[]) => {
    //     let filtered = [] as Member[];
    //     _membersList.map((member: Member) => {
    //         // console.log('checkFilterType: ' + MatchMemberTypeIDWithLabel(member.member_typeID, 'Corporate'));
    //         if (filter_memberTypeID != '' && member.member_typeID == filter_memberTypeID) {
    //             filtered.push(member);
    //         } else if (
    //             filter_memberTypeID == ''
    //             && !MatchMemberTypeIDWithLabel(member.member_typeID, 'Corporate')
    //             && !MatchMemberTypeIDWithLabel(member.member_typeID, 'Individual')
    //         ) {
    //             filtered.push(member);
    //         }
    //     });
    //     return filtered
    // } ---attempt deprecated
    const FilterListBySearchString = (memberList: Member[], nameList?: NameListMap[]) => {
        let filtered = [] as Member[];
        memberList.map((member: Member, i: number) => {
            let isFiltered = false;
            if (
                member.company_name.toLowerCase().includes(filter_searchString.toLowerCase())
                || member.website.toLowerCase().includes(filter_searchString.toLowerCase())
                || member.complex_representing.toLowerCase().includes(filter_searchString.toLowerCase())
            ) {
                filtered.push(member);
                isFiltered = true;
            }

            if (!isFiltered && nameList != undefined && nameList.length == memberList.length) {
                const list = nameList[i];
                if (list.name != null && list.name.toLowerCase().includes(filter_searchString.toLowerCase()))
                    filtered.push(memberList[i]);
            }
        });
        return filtered;
    }
    const MatchMemberTypeIDWithLabel = (memberTypeID: string, label: string) => {
        let memberTypeLabel = '';
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (memberType.member_typeID == memberTypeID)
                memberTypeLabel = memberType.label;
        });

        if (label != 'Other' && memberTypeLabel == label)
            return true;
        else if (label == 'Other' && memberTypeLabel == '')
            return true;
        else
            return false;

    }
    const GetMemberTypeIDByLabel = (label: string) => {
        let res = '';
        if (label != 'Other') {
            exAppContext.memberTypes.map((memberType: MemberType) => {
                if (memberType.label == label)
                    res = memberType.member_typeID;
            });
        } else {
            return '';
        }
        return res;
    }
    // const GetNameByMemberID = (memberID: string) => {
    //     let res = '';
    //     nameList.map((nameListMap: NameListMap) => {
    //         if (nameListMap.memberID == memberID)
    //             res = nameListMap.name;
    //     });
    //     return res;
    // } --deprecated
    // const OnMemberListBtnClicked = async (website: string) => {
    //     if (website.length > 0) {
    //         appContext.SetAppStateChangeWatch(false);
    //         Browser.addListener('browserFinished', () => {
    //             appContext.SetAppStateChangeWatch(true);
    //         });
    //         await Browser.open({ url: website });
    //     }
    // } ---deprecated
    const SortAlphabetically = (memberList: Member[]) => {
        const sorted = [] as Member[];
        // console.log('checksum: ' + JSON.stringify(individualMemberNameList));
        memberList.map((member: Member, u: number) => {
            let isSorted = false;
            sorted.map((_member: Member, i: number) => {
                if (MatchMemberTypeIDWithLabel(member.member_typeID, 'Corporate')) {
                    if (
                        !isSorted
                        && member.complex_representing.localeCompare(_member.complex_representing) == -1
                    ) {
                        sorted.splice(i, 0, member);
                        isSorted = true;
                    }
                } else if (MatchMemberTypeIDWithLabel(member.member_typeID, 'Individual')) {

                    // if (individualMemberNameList[u] == undefined) {
                    //     console.log('checkUndefined: ' + JSON.stringify(memberList));
                    //     console.log('checkU: ' + u);
                    // }

                    const name1 = GetNameByMemberID(individualMemberNameList, member.memberID)//individualMemberNameList[u].name;
                    const name2 = GetNameByMemberID(individualMemberNameList, _member.memberID)//individualMemberNameList[i].name;

                    if (
                        !isSorted
                        && name1 != null
                        && name2 != null
                        && name1.localeCompare(name2) == -1
                    ) {
                        sorted.splice(i, 0, member);
                        isSorted = true;
                    }
                } else if (MatchMemberTypeIDWithLabel(member.member_typeID, 'Honorary Member')) {
                    const name1 = GetNameByMemberID(honoraryMemberNameList, member.memberID);
                    const name2 = GetNameByMemberID(honoraryMemberNameList, _member.memberID);

                    if (
                        !isSorted
                        && name1 != null
                        && name2 != null
                        && name1.localeCompare(name2) == -1
                    ) {
                        sorted.splice(i, 0, member);
                        isSorted = true;
                    }
                } else if (MatchMemberTypeIDWithLabel(member.member_typeID, 'Associate')) {

                    const name1 = GetNameByMemberID(associateMemberNameList, member.memberID);//associateMemberNameList[u].name;
                    const name2 = GetNameByMemberID(associateMemberNameList, _member.memberID);//associateMemberNameList[i].name;

                    if (
                        !isSorted
                        && name1 != null
                        && name2 != null
                        && name1.localeCompare(name2) == -1
                    ) {
                        sorted.splice(i, 0, member);
                        isSorted = true;
                    }
                } else if (MatchMemberTypeIDWithLabel(member.member_typeID, 'Affiliate Corporate')) {
                    if (
                        !isSorted
                        && member.company_name.localeCompare(_member.company_name) == -1
                    ) {
                        sorted.splice(i, 0, member);
                        isSorted = true;
                    }
                } else if (MatchMemberTypeIDWithLabel(member.member_typeID, 'Affiliate Individual')) {
                    const name1 = GetNameByMemberID(affiliateIndividualMemberNameList, member.memberID);//affiliateIndividualMemberNameList[u].name;
                    const name2 = GetNameByMemberID(affiliateIndividualMemberNameList, _member.memberID);//affiliateIndividualMemberNameList[i].name;
                    if (
                        !isSorted
                        && name1 != null
                        && name2 != null
                        && name1.localeCompare(name2) == -1
                    ) {
                        sorted.splice(i, 0, member);
                        isSorted = true;
                    }
                }
            });
            if (!isSorted)
                sorted.push(member);
        });
        return sorted;
    }
    const GetNameListByFilterMemberTypeID = (filter_memberTypeID: string) => {
        let res = [] as NameListMap[];

        if (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Individual'))
            res = individualMemberNameList;
        else {
            res = res.concat(honoraryMemberNameList);
            res = res.concat(associateMemberNameList);
            res = res.concat(affiliateIndividualMemberNameList);
        }

        return res;
    }
    const GetNameByMemberID = (list: any[], memberID: string) => {
        let res = '';
        list.map((list: any) => {
            if(list.memberID == memberID)
                res = list.name;
        });
        return res;
    }

    //check functions
    const IsCorporate = (member: Member) => {
        let res = false;
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (
                member.member_typeID == memberType.member_typeID
                && memberType.label.toLowerCase().includes('corporate')
            )
                res = true;
        });
        return res;
    }

    return (
        <div className={'MembersList ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='search-bar-block'>
                <input className='search-bar-in' value={filter_searchString} onChange={(e: any) => SetFilter_searchString(e.target.value)} placeholder='type name to search' />
                <SearchIcon />
            </div>
            <div className='member-list-block'>
                <div className='option-panel'>
                    <button className={'option-panel-btn ' + (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Corporate') ? 'selected' : '')} onClick={() => SetFilter_memberTypeID(GetMemberTypeIDByLabel('Corporate'))}>
                        {
                            MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Corporate') ?
                                "Corporate Members "
                                :
                                ""
                        }
                        <GroupIcon />
                    </button>
                    <button className={'option-panel-btn ' + (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Individual') ? 'selected' : '')} onClick={() => SetFilter_memberTypeID(GetMemberTypeIDByLabel('Individual'))}>
                        {
                            MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Individual') ?
                                "Individual Members "
                                :
                                ""
                        }
                        <PersonIcon />
                    </button>
                    <button className={'option-panel-btn ' + (MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Other') ? 'selected' : '')} onClick={() => SetFilter_memberTypeID(GetMemberTypeIDByLabel('Other'))}>
                        {
                            MatchMemberTypeIDWithLabel(filter_memberTypeID, 'Other') ?
                                "Other Members "
                                :
                                ""
                        }
                        <PeopleOutlineIcon />
                    </button>
                </div>
                <div className='member-list-scroll' ref={memberListScrollRef}>
                    {RenderMembersList()}
                </div>
            </div>
        </div>
    );
}
export default MembersList;